export default "__VITE_ASSET__0d246d44__"